import { CurrencyEnum, cents } from '@systemeio/ui'
import { AffiliateSumType } from 'modules/affiliate-program/affiliate/types/affiliate-interface'

export const getChartValue = (chartValue: AffiliateSumType[CurrencyEnum]) =>
  chartValue ? chartValue : cents(0)
